import { getAPIURL } from '@utils/api'
import { websocketStore } from './websocketStore'

let socket: WebSocket | null = null
let retryCount = 0

export function connectWebSocket() {
  const apiUrl = getAPIURL()
  let socketUrl = apiUrl.replace('https', 'wss').concat('websockets/open_data_stream')
  if (apiUrl.includes('localhost')) {
    socketUrl = apiUrl.replace('http', 'ws').concat('websockets/open_data_stream')
  }

  socket = new WebSocket(socketUrl)

  socket.onopen = () => {
    retryCount = 0
  }

  socket.onmessage = (event: MessageEvent) => {
    if (!event.data) return
    try {
      const data = JSON.parse(event.data)
      const updates: Record<string, any> = {}

      if (data.auto_dispatch_locked_schedules) {
        updates.lockedSchedules = data.auto_dispatch_locked_schedules
      }

      if (data.auto_dispatch_locked_orders) {
        updates.lockedOrders = data.auto_dispatch_locked_orders
      }

      if (data.auto_dispatch_run_status) {
        updates.runStatus = data.auto_dispatch_run_status
      }

      if (data.store_tanks) {
        updates.forecastOverrideStatus = data
      }

      if (data.user_tasks) {
        updates.userTasks = data.user_tasks
      }

      if (Object.keys(updates).length) {
        websocketStore.update(updates)
      }
    } catch (err) {
      console.error('Failed to parse WebSocket message:', err)
    }
  }

  socket.onclose = () => {
    console.warn('WebSocket closed, attempting to reconnect…')
    retryCount++
    if (retryCount <= 5) {
      setTimeout(connectWebSocket, 1000 * retryCount)
    } else {
      console.error('WebSocket failed to reconnect after 5 attempts.')
    }
  }
}

export function disconnectWebSocket() {
  if (socket) {
    socket.close()
    socket = null
  }
}
